<template>
  <div>
    <b-row align-h="center" class="mt-2">
      <b-col v-if="bannerCount == 1" cols="12" md="8" lg="6">
        <div style="margin: 4px 8px 0px 0px;">
            <b-img :src="getBanner(0)" fluid  @click="showModal=true"></b-img>
        </div>
      </b-col>
      <b-col v-else cols="12">
        <div style="margin: 4px 8px 0px 0px;">
          <div class="d-block d-sm-none">
            <b-img :src="getBanner(0)" fluid  @click="showModal=true"></b-img>
          </div>
          <div class="d-none d-sm-block d-md-none">
            <b-img :src="getBanner(2)" fluid  @click="showModal=true"></b-img>
          </div>
          <div class="d-none d-md-block d-lg-none">
            <b-img :src="getBanner(1)" fluid  @click="showModal=true"></b-img>
          </div>
          <div class="d-none d-lg-block d-xl-none">
            <b-img :src="getBanner(2)" fluid  @click="showModal=true"></b-img>
          </div>
          <div class="d-none d-xl-block">
            <b-img :src="getBanner(3)" fluid  @click="showModal=true"></b-img>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-modal v-model="showModal" @show="showEvent" @hidden="hiddenEvent">
      <b-overlay :show="busy">
        <div v-if="!submitted">
          <div v-if="!haveEmail">  <!-- prompt for email -->

            <b-form @submit.stop.prevent="submitEmail">

              <b-form-group label="" label-for="email" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                <b-input-group class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="envelope"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                    id="email"
                    v-model.trim.lazy="$v.form.email.$model"
                    type="email"
                    placeholder="Your email address"
                    :state="validateState('email')"
                    aria-describedby="support-email-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback v-if="!$v.form.email.required">Email is required.</b-form-invalid-feedback>
                  <b-form-invalid-feedback v-if="!$v.form.email.email">Enter valid email address.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>

              <transition name="fade" mode="out-in">
                <div>
                  <b-alert v-model="error" key="error-box" show variant="danger" dismissible class="mt-2">
                    {{errorMsg}}
                  </b-alert>
                </div>
              </transition>

              <div class="text-center">
                <b-button type="submit">{{mobileAd.buttonText}}</b-button>
              </div>
            </b-form>

          </div>
          <div v-else>  <!-- have email -->
            <!-- <div>
              {{email}}
            </div> -->
            <div class="text-center">
              <b-button @click="submit">{{mobileAd.buttonText}}</b-button>
            </div>
          </div>
          <div class="mt-2">
            <b-img :src="getBanner(0)" fluid></b-img>
          </div>
          <div class="mt-2">
            {{mobileAd.blurb}}
          </div>
        </div>
        <div v-else>  <!-- show response -->
          <div>
            <h3>{{mobileAd.confirmationMessageTitle}}</h3>
          </div>
          <div>
            {{mobileAd.confirmationMessage}}
          </div>
          <div class="text-center mt-2">
            <b-button @click="showModal=false">Close</b-button>
          </div>
        </div>
      </b-overlay>
      <template v-slot:modal-footer>&nbsp;<!-- empty --></template>
    </b-modal>
  </div>
</template>

<script>
'use strict'
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"

import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: "MobileAd",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: '',
      showModal: false,
      busy: true,
      submitted: false,
      haveMobileAd: false,
      mobileBanners: null,
      bannerCount: 0,
      mobileAd: {buttonText: 'Click here', blurb: 'Text forthcoming'},
      studentHash: this.$root.getToken(),
      email: this.$root.getStudentEmail(),
      form: {
        email: null
      }
    }
  },
  props: {
    mb: {  // mobileAd banner object
      type: Object
    },
    s: {  // studentHash
      type: String,
      default: null
    },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      email: {
        required,
        email
      }
    }
  },
  computed: {
    getModalName() {
      let x = 'mobilead-' + this.mobileBanners.adId
      // console.log(`getModalName: ${x}`)
      return x
    },
    haveEmail() {
      return (this.email && this.email.length !== 0)
    }
   },
  methods: {
    validateState(name) {
      // console.log(`name: ${name}`)
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null;
    },
    getBanner(ix) {
      // 0: small portrait
      // 1: small landscape
      // 2: large portrait
      // 3: large landscape
      return this.mobileBanners.adUrls[ix]
    },
    showEvent(e) {
      if (this.haveMobileAd) return
      this.busy = true
      service
        .getMobileAd(this.mobileBanners.adId, this.studentHash)
        .then(res => {
          if (this.debug) console.log(res);
          if (res.status && res.rowCount !== 0) {
            this.mobileAd = res.data[0]
            this.haveMobileAd = true
          }
          else {
            console.log('Error! getMobileAd()')
          }
        })
        .finally(() => this.busy = false)
        .catch(e => console.log(e))
    },
    hiddenEvent() {
      // console.log('modal hidden')
      this.submitted = false
      this.error = false
      this.$v.form.$reset()
      // Remove supplied email addres sif student not logged in.
      if (this.studentHash.length === 0) this.email = null
    },
    submitEmail(e) {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        console.log(`ERROR!!`)
        this.errorMsg = 'Correct errors and resubmit.'
        this.error = true
        return
      }
      this.busy = true
      this.email = this.form.email
      this.form.email = null
      this.submit(e)
    },
    submit(e) {
      this.busy = true
      service
        .submitMobileAd(this.mobileBanners.adId, this.studentHash, this.email)
        .then(res => {
          if (this.debug) console.log(res);
          if (res.status) {
            this.submitted = true
          }
          else {
            console.log('Error! getMobileAd()')
          }
        })
        .finally(() => {
          this.busy = false
        })
        .catch(e => console.log(e))
    }
  },
  created() {
    // console.log(this.mb)
    this.mobileBanners = this.mb || {adId: 0, adUrls: []}
    this.bannerCount = this.mobileBanners.adUrls.length
  },
  mounted() {},
  beforeDestroy() {}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/MobileAd.vue